import { v4 as uuidv4 } from 'uuid';
import { SliderLayout as SliderLayoutComponent } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function SliderLayout() {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'SliderLayout',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Slider Layout (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'slider-layout-2__flex-row', horizontalAlign: 'center', mzTitle: 'MZ | Banner' }, [
				StoreImageList(
					{
						preload: true,
						images: [
							{
								image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								mobileImage: 'https://hefesto-upload-images.s3.amazonaws.com/1683045718304-sliderLayout-2-mobile-2.png',
								description: 'Imagem',
							},
							{
								image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								mobileImage: 'https://hefesto-upload-images.s3.amazonaws.com/1683045718304-sliderLayout-2-mobile-2.png',
								description: 'Imagem2',
							},
						],
					},
					[
						SliderLayoutComponent({
							mzTitle: 'Layout do slider',
							blockClass: 'home__slider-2',
						}),
					],
				),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--white',
				to: '--slider-2-arrow-color',
				name: 'Arrow',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--slider-2-arrow-background',
				name: 'Botão do Slider',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--slider-2-dots',
				name: 'Slider Dots',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--slider-2-dotsss',
				name: 'Teste',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--slider-2-border-radius', name: 'Botão do Slider' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-sm', to: '--slider-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-nano', to: '--slider-2-dot-height', name: 'Altura Dot' },
			{ from: '--spacing-sm', to: '--slider-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--slider-2-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-md', to: '--slider-2-button-size', name: 'Slider Button' },
			{ from: '--spacing-sm', to: '--slider-2-dots-bottom', name: 'Margem inferior Dots' },
		],
	},
];
